module.exports = __webpack_public_path__ + "static/img/base-layer.60fd6759.svg";